<template>
    <div class="fixed-header-top-div" style="margin-bottom:15px">
        <div style="overflow-x:auto">
            <el-table :data="tableData">
                <el-table-column v-for="col in tableColumns"
                v-bind:key="col.key"
                :label="$t(col.label)"
                :prop="col.key"
                :render-header="renderHeader"
                >
                </el-table-column>
            </el-table>
        </div>
        
    </div>
</template>

<script>
import emCustomVuexMixin from "@/mixin/em/customVuex";
export default {
    name: "AverageTable",
    mixins:[emCustomVuexMixin],
    props: {
        calculateColumns: {
            type: Array,
            default: []
        },
        entity: String,
    },
    computed: {
        tableColumns() {
            let gridFields = this.$_emCustomVuexMixin_voConfigs;
            if(this.calculateColumns.length === 0) {
                return gridFields;
            }
            let columns = [{key:'average_value',label:''}];
            this.calculateColumns.forEach(cc => {
                gridFields.find(f => f.key === cc) && columns.push(gridFields.find(f => f.key === cc));
            })
            return columns;
        },
        columnKeys() {
            if(this.calculateColumns.length === 0) {
                return this.$_emCustomVuexMixin_voConfigs.map(v => v.key);
            }
            return this.calculateColumns;
        },
        nanTag(){
            return '-'
        },
        tableData() {
            let rows = this.$_emCustomVuexMixin_voStore;
            let result = [];
            let averageRow = this.columnKeys.reduce((prev, key) => {
                let value = this.calcAverage(rows.map(v => Number.parseFloat(v[key])).filter(v => !isNaN(v))).toFixed(2);
                prev[key] = isNaN(value)?this.nanTag:value;
                return prev;
            },{average_value:'平均值'});
            result.push(averageRow);
            // this.columnKeys.forEach(key => {
            //     let value = this.calcAverage(rows.map(v => Number.parseFloat(v[key])).filter(v => !isNaN(v))).toFixed(2);
            //     let obj = {};
            //     obj[key]=value;
            //     result.push(obj);
            // });
            return result;
        },

    },
    methods: {
        calcAverage(arr) {
            return arr.reduce((s, v) => s + v, 0) / arr.length
        },
        renderHeader(h, { column, $index }) {
            let realWidth = 0;
            let span = document.createElement('span');
            span.innerText = column.label;
            document.body.appendChild(span);
            realWidth = span.getBoundingClientRect().width;
            column.minWidth = realWidth;
            document.body.removeChild(span);
            return h('span',column.label);
        }
    }
}
</script>